import axios from "axios";
import React, { useState } from "react";
import style from "css/menu.module.css";
import { Cascader, Checkbox } from "antd";
import MeetingRoomInfoModal from "components/calendar/meetingRoomInfoModal";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function RiEndpointSideBox({
  isOpenEndpointSideBox,
  closeEndpointSideBox,
  searchEndpointList,
  setSearchEndpointList,
  schedule,
  setSchedule,
  dateTimes,
}) {
  const { t } = useTranslation();
  const [endpointDeptList, setEndpointDeptList] = useState([]);

  useEffect(() => {
    setEndpointDeptOption();
  }, [isOpenEndpointSideBox]);

  const setEndpointDeptOption = () => {
    axios
      .get("/schedule/deptList")
      .then((res) => {
        if (res.status === 200) {
          setEndpointDeptList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const endpointChange = (e) => {
    setSchedule((pre) => {
      const filteredList = pre.ENDPOINT_LIST.filter((item) => {
        // return !e.ENDPOINT_ID.includes(item.ENDPOINT_ID);
        return e.ENDPOINT_ID !== item.ENDPOINT_ID;
      });

      if (e.isChecked) {
        filteredList.push(e);
      }
      return { ...pre, ENDPOINT_LIST: filteredList };
    });
  };

  const onChangeEndpointDept = (valueArr) => {
    if (valueArr !== undefined) {
      var lastValue = valueArr[valueArr.length - 1];
      const param = {
        params: {
          DEPT_CD: lastValue,
          START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
          END_TIME: dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00",
        },
      };

      axios
        .get("schedule/getAvailableEndpointList", param)
        .then((res) => {
          if (res.status === 200) {
            let updatedEndpoints = [];

            res.data.ENDPOINT.map((endpoint) => {
              const updatedEndpoint = schedule.ENDPOINT_LIST.find(
                (e) => endpoint.ENDPOINT_ID === e.ENDPOINT_ID
              );
              if (updatedEndpoint) {
                return updatedEndpoints.push({
                  id: endpoint.ENDPOINT_ID,
                  title: endpoint.ENDPOINT_NM,
                  extendedProps: endpoint,
                  ENDPOINT_ID: endpoint.ENDPOINT_ID,
                  ENDPOINT_NM: endpoint.ENDPOINT_NM,
                  ENDPOINT_TYPE: endpoint.ENDPOINT_TYPE,
                  ENDPOINT_IP: endpoint.ENDPOINT_IP,
                  DEPT_CD: endpoint.DEPT_CD,
                  DEPT_NM: endpoint.DEPT_NM,
                  isChecked: !endpoint.isChecked,
                });
              } else {
                return updatedEndpoints.push({
                  id: endpoint.ENDPOINT_ID,
                  title: endpoint.ENDPOINT_NM,
                  extendedProps: endpoint,
                  ENDPOINT_ID: endpoint.ENDPOINT_ID,
                  ENDPOINT_NM: endpoint.ENDPOINT_NM,
                  ENDPOINT_TYPE: endpoint.ENDPOINT_TYPE,
                  ENDPOINT_IP: endpoint.ENDPOINT_IP,
                  DEPT_CD: endpoint.DEPT_CD,
                  DEPT_NM: endpoint.DEPT_NM,
                });
              }
            });
            setSearchEndpointList(updatedEndpoints);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // checkbox status update
  const handleSearchEndpointCheck = (endpoint) => {
    if (
      schedule.SCHEDULE_TYPE === "CD0205" &&
      schedule.ENDPOINT_LIST.length === 1
    ) {
      if (!endpoint.isChecked || endpoint.isChecked === null) {
        return;
      }
    }

    setSearchEndpointList(
      searchEndpointList.map((e) =>
        e.ENDPOINT_ID === endpoint.ENDPOINT_ID
          ? { ...e, isChecked: !e.isChecked }
          : e
      )
    );
    endpoint.isChecked = !endpoint.isChecked;

    endpointChange(endpoint);
  };

  return (
    <div
      className={`${style.res_popup_sideBox} ${
        isOpenEndpointSideBox ? style.expandedri : ""
      }`}
    >
      <div className={style.res_popup_sideBox_containerri}>
        <div className={style.res_popup_sideBox_container_headerri}>
          <div className={style.res_popup_sideBox_recycleIcon_bg}>
            <img
              className={`${style.res_popup_sideBox_recycleIcon} ${
                isOpenEndpointSideBox ? style.expanded : ""
              }`}
              src={process.env.REACT_APP_CLIENT_URL + "img/menu/sync.png"}
              alt="sync"
            />
          </div>

          <div className={style.sideBox_titleArea}>
            <span>{t("LABEL.TITLE.MEETING_ROOM")}</span>
            <img
              className={style.res_popup_sideBox_closeBtn}
              src={process.env.REACT_APP_CLIENT_URL + "img/menu/close.png"}
              alt="close"
              onClick={closeEndpointSideBox}
            />
          </div>
          <div className={style.res_popup_sideBox_container_content}>
            <div className={style.res_popup_input_label}>
              {t("LABEL.MEETING_PLACE")}
            </div>
            <div className={style.res_popup_endpoint_cascader}>
              <Cascader
                options={endpointDeptList}
                onChange={onChangeEndpointDept}
                placeholder={t("PLACEHOLDER.INPUT.SELECT_PLACE")}
                style={{ width: "100%", fontSize: "13px" }}
                size="large"
                changeOnSelect={onChangeEndpointDept}
              />
            </div>
            <div>
              {searchEndpointList.map((endpoint) => (
                <ul
                  key={endpoint.ENDPOINT_ID}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    listStyleType: "none",
                    margin: 0,
                    padding: "4px 0px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontSize: "15px",
                    fontWeight: "normal",
                    color: "#333333",
                  }}
                >
                  <li style={{ marginRight: 10 }}>
                    <Checkbox
                      checked={endpoint.isChecked}
                      onChange={() => handleSearchEndpointCheck(endpoint)}
                    />
                  </li>
                  <li style={{ marginRight: 10, width: "60%" }}>
                    {endpoint.ENDPOINT_NM}
                  </li>
                  <li style={{ marginRight: 10 }}>
                    <MeetingRoomInfoModal resource={endpoint} />
                  </li>
                  <li style={{ marginRight: 10 }}>
                    {endpoint.ENDPOINT_TYPE !== "CD1001" && (
                      <img
                        src={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/menu/video-camera.png"
                        }
                        alt="video-camera"
                        // style={{paddingTop:"5px"}}
                      />
                    )}
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
